/* eslint-disable camelcase */
import DepressableButton from '../library/DepressableButton';

export default class SoundButton {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;
    this.mute = this.scene.sound.mute;
    this.activateSoundGraphic = 'soundButton';
    this.activateSoundGraphic_Depressed = 'soundButton_Depressed';
    this.inactivateSoundGraphic = 'muteButton';
    this.inactivateSoundGraphic_Depressed = 'muteButton_Depressed';

    const buttonScale = .28;
    const buttonX = this.scene.scale.width - 60;
    const buttonY = 60;

    this.button = new DepressableButton(scene, buttonX, buttonY, 'soundButton', 'soundButton_Depressed', () => {this.eh_SoundButton_Clicked();});
    this.button.button.setScale(buttonScale);

    this.updateTexture();
  }

  updateTexture() {
    if (this.mute) {
      this.button.setTextures(this.inactivateSoundGraphic, this.inactivateSoundGraphic_Depressed);
    }
    else {
      this.button.setTextures(this.activateSoundGraphic, this.activateSoundGraphic_Depressed);
    }
  }

  eh_SoundButton_Clicked() {
    this.mute = !this.mute;
    this.scene.sound.mute = this.mute;

    this.updateTexture();
  }
}